/* eslint-disable react/no-find-dom-node */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalOpen, modalType } from '../../redux/actions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Group from '../Group';
import Button from '../Button';
import Text from '../Text';
import Image from '../Image';
import Lottie from '../LottieControl';
import firebase, {
  userDashboardListner,
  dashboardListner,
  masterListner,
} from '../../firebase';
import theme, { rem } from '../../theme';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
`;

const StyledTextIntro = styled(Text)`
  margin-bottom: ${rem(20)};
`;

const StyledImage = styled(Image)`
  margin-bottom: ${rem(20)};
  width: 100%;
  height: ${rem(250)};
  object-fit: contain;
`;

const StyledText = styled(Text)`
  margin-bottom: ${rem(10)};
`;

const StyledContentWrapper = styled(Group)`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

const StyledButtonGroup = styled(Group)`
  margin-top: ${rem(20)};

  button {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: ${rem(20)};
    width: ${rem(350)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledMessage = styled(Text)`
  background: ${theme.color.dark[40]};
  padding: ${rem(8)} ${rem(10)};
  border-radius: ${rem(5)};
}
`;

const StyledLoading = styled(Lottie)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledGroup = styled(Group)`
  flex-direction: column;
  margin-bottom: ${rem(10)};

  &:last-child {
    margin-bottom: 0;
  }
`;

/** todo */
const setMaster = props => {
  const { activeDashboardId, id, closeModals } = props;
  const uuid = firebase.auth().currentUser.uid;

  //States
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({});

  //Translation
  const [t] = useTranslation(['modal', 'button']);

  useEffect(() => {
    if (id) getData();
    document.getElementById('globalModal').firstElementChild.style.height =
      'auto';
    document.getElementById('globalModal').firstElementChild.style.width =
      '30rem';
  }, []);

  /** Get all the dashboard data */
  const getData = () => {
    dashboardListner.child(id).once('value', snapshot => {
      if (snapshot.val()) {
        setDashboardData(snapshot.val());
        setLoading(false);
      }
    });
  };

  /** Switch master dashboard */
  const switchDashboard = () => {
    userDashboardListner
      .child(uuid)
      .child(id)
      .child('backgroundimage')
      .once('value', snapshot => {
        masterListner.update({
          dashboard: {
            id: id,
          },
          backgroundimage: snapshot.val(),
        });
      });
  };

  /** Return Chat messages */
  return loading ? (
    <StyledLoading animation='loading' animationWidth={400} />
  ) : (
    <StyledWrapper>
      <StyledContentWrapper fullwidth>
        <StyledText
          align='center'
          text={t('modal:setmaster.title')}
          textColor='#fff'
          textStyle='h3'
          tag='h1'
        />

        <StyledTextIntro
          align='center'
          text={t('modal:setmaster.text')}
          textColor='#fff'
          textStyle='h6'
          tag='p'
        />

        <StyledButtonGroup fullwidth>
          <Button
            variant='contained'
            onClick={() => {
              if (id) switchDashboard();
              closeModals();
            }}
            bgColor={theme.color.success}
            text={{
              align: 'center',
              text: t('button:switch.text'),
              textColor: '#fff',
            }}
          />
          <Button
            variant='contained'
            text={{
              align: 'center',
              text: t('button:cancel.cancel'),
              textColor: '#fff',
            }}
            onClick={() => {
              closeModals();
            }}
            bgColor={theme.color.cancel}
          />
        </StyledButtonGroup>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

setMaster.propTypes = {
  /** Active dashboard Id */
  activeDashboardId: PropTypes.string,
  /** User Id */
  id: PropTypes.string,
  /** Close function for the modal */
  closeModals: PropTypes.func,
};

setMaster.defaultProps = {
  activeDashboardId: null,
  id: null,
  location: null,
};

export default setMaster;
